var menuInfo = {
  //客户
  company: {
    'home': [{
      "name": "首页",
      "level": 2,
      "path": "ci0801",
      "id": 11,
      "icon": "home"
    }],
    'monitoring': [{
      "name": "我的设备",
      "level": 2,
      "path": "ci0101",
      "id": 21,
      "icon": "database"
    }, {
      "name": "我的链路",
      "level": 2,
      "path": "ci0101",
      "id": 22,
      "icon": "share-alt",
      "sub": [{
        "name": "常规链路",
        "level": 3,
        "parent_id": 22,
        "path": "bi1803",
        "id": 221,
        "icon": null
      }, {
        "name": "FullMesh链路",
        "level": 3,
        "parent_id": 22,
        "path": "bi1801",
        "id": 222,
        "icon": null
      }]
    }, {
      "name": "我的客户端",
      "level": 2,
      "id": 23,
      "path": "ci4301",
      "icon": "desktop"
    },
    // {
    //     "name": "地图模式",
    //     "level": 2,
    //     "id": 24,
    //     "path": "ci4201",
    //     "icon": "global"
    // },
    {
      "name": "告警信息",
      "level": 2,
      "id": 25,
      "path": "ci2501",
      "icon": "alert"
    }, {
      "name": "操作日志",
      "level": 2,
      "id": 26,
      "path": "ci2401",
      "icon": "file-text"
    }, {
      "name": "用户访问日志",
      "level": 2,
      "id": 27,
      "path": "ci2402",
      "icon": "code"
    }],
    'configuration': [{
      "name": "构建网络",
      "level": 2,
      "path": "ci2001",
      "id": 31,
      "icon": "deployment-unit",
      "sub": [{
        "name": "中心节点",
        "level": 3,
        "parent_id": 31,
        "path": "ci2101",
        "id": 311,
        "icon": null
      }, {
        "name": "边缘节点",
        "level": 3,
        "parent_id": 31,
        "path": "ci2201",
        "id": 312,
        "icon": null
      } // {
      //     "name": "设备配置",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "ci2801",
      //     "id": 313,
      //     "icon": null
      // }, {
      //     "name": "设备绑定",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "ci3001",
      //     "id": 314,
      //     "icon": null
      // },
      // {
      //     "name": "中心线路配置",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "ci1401",
      //     "id": 316,
      //     "icon": null
      // },
      // {
      //     "name": "HA配置",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "bi2501",
      //     "id": 315,
      //     "icon": null
      // },
      // {
      //     "name": "白名单",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "ci0901",
      //     "id": 318,
      //     "icon": null
      // },
      ]
    },
    // {
    //     "name": "QoS配置",
    //     "level": 2,
    //     "id": 32,
    //     "path": "ci0500",
    //     "icon": "control",
    //     "sub": [
    //         {
    //             "name": "隧道QoS",
    //             "level": 3,
    //             "parent_id": 32,
    //             "path": "ci0601",
    //             "id": 321,
    //             "icon": null
    //         },
    //         {
    //             "name": "互联网QoS",
    //             "level": 3,
    //             "parent_id": 32,
    //             "path": "ci3901",
    //             "id": 322,
    //             "icon": null
    //         },
    //         {
    //             "name": "单IP限速",
    //             "level": 3,
    //             "parent_id": 32,
    //             "path": "ci4001",
    //             "id": 324,
    //             "icon": null
    //         },{
    //             "name": "IP限速",
    //             "level": 3,
    //             "parent_id": 32,
    //             "path": "ci3906",
    //             "id": 326,
    //             "icon": null
    //         },
    //     ]
    // },
    {
      "name": "安全防护",
      "level": 2,
      "path": "ci3800",
      "icon": "safety",
      "id": 33,
      "sub": [{
        "name": "ACL2.0",
        "level": 3,
        "parent_id": 33,
        "path": "ci0502",
        "id": 330,
        "icon": null
      }, {
        "name": "ACL配置",
        "level": 3,
        "parent_id": 33,
        "path": "ci0501",
        "id": 331,
        "icon": null
      } // {
      //     "name": "Mac访问控制",
      //     "level": 3,
      //     "parent_id": 35,
      //     "path": "ci4101",
      //     "id": 332,
      //     "icon": null
      // },
      // {
      //     "name": "基础防护",
      //     "level": 3,
      //     "parent_id": 35,
      //     "path": "ci4102",
      //     "id": 333,
      //     "icon": null
      // },
      ]
    }, {
      "name": "客户端配置",
      "level": 2,
      "path": "ci3700",
      "icon": "desktop",
      "id": 34,
      "sub": [{
        "name": "客户端账号",
        "level": 3,
        "parent_id": 34,
        "path": "ci0702",
        "id": 341,
        "icon": null
      }, {
        "name": "客户端网段",
        "level": 3,
        "parent_id": 34,
        "path": "ci3701",
        "id": 342,
        "icon": null
      }, {
        "name": "Mac认证",
        "level": 3,
        "parent_id": 34,
        "path": "ci3703",
        "id": 343,
        "icon": null
      }]
    }, {
      "name": "告警配置",
      "level": 2,
      "path": "ci2600",
      "icon": "alert",
      "id": 35,
      "sub": [{
        "name": "告警接收",
        "level": 3,
        "parent_id": 35,
        "path": "mi2601",
        "id": 351,
        "icon": null
      }, {
        "name": "告警事件",
        "level": 3,
        "parent_id": 35,
        "path": "ci2602",
        "id": 352,
        "icon": null
      } // {
      //     "name": "健康标准",
      //     "level": 3,
      //     "parent_id": 35,
      //     "path": "ci2603",
      //     "id": 353,
      //     "icon": null
      // },
      ]
    },
    // {
    //     "name": "高级配置",
    //     "level": 2,
    //     "path": "ci3700",
    //     "icon": "setting",
    //     "id": 36,
    //     "sub": [
    //         {
    //             "name": "源地址引流",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci3904",
    //             "id": 361,
    //             "icon": null
    //         },
    //         {
    //             "name": "多线路负载",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci4105",
    //             "id": 362,
    //             "icon": null
    //         },
    //         {
    //             "name": "多线路DNS代理",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci4106",
    //             "id": 363,
    //             "icon": null
    //         },
    //         {
    //             "name": "域名解析",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci4104",
    //             "id": 364,
    //             "icon": null
    //         },
    //         {
    //             "name": "Wi-Fi配置",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci4103",
    //             "id": 365,
    //             "icon": null
    //         },
    //     ]
    // },
    // {
    //     "name": "模版配置",
    //     "level": 2,
    //     "path": "ci3300",
    //     "id": 37,
    //     "icon": "container",
    //     "sub": [
    //         {
    //             "name": "LAN模版",
    //             "level": 3,
    //             "parent_id": 37,
    //             "path": "ci3301",
    //             "id": 371,
    //             "icon": null
    //         },
    //         {
    //             "name": "SSID模版",
    //             "level": 3,
    //             "parent_id": 37,
    //             "path": "ci3201",
    //             "id": 372,
    //             "icon": null
    //         },
    //         {
    //             "name": "CPE模版",
    //             "level": 3,
    //             "parent_id": 37,
    //             "path": "ci3101",
    //             "id": 373,
    //             "icon": null
    //         },
    //     ]
    // },
    {
      "name": "应用管理",
      "level": 2,
      "path": "ci3800",
      "icon": "appstore",
      "id": 38,
      "sub": [{
        "name": "自定义应用",
        "level": 3,
        "parent_id": 38,
        "path": "ci3801",
        "id": 381,
        "icon": null
      }, {
        "name": "自定义分组",
        "level": 3,
        "parent_id": 38,
        "path": "ci3803",
        "id": 382,
        "icon": null
      } // {
      //     "name": "系统应用",
      //     "level": 3,
      //     "parent_id": 38,
      //     "path": "ci3802",
      //     "id": 383,
      //     "icon": null
      // },
      ]
    }, {
      "name": "对象分组",
      "level": 2,
      "id": 39,
      "path": "ci1501",
      "icon": "folder-open",
      "sub": [{
        "name": "节点分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1502",
        "id": 391,
        "icon": null
      }, {
        "name": "域名分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1503",
        "id": 392,
        "icon": null
      }, {
        "name": "IP分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1601",
        "id": 393,
        "icon": null
      }, {
        "name": "用户分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1602",
        "id": 394,
        "icon": null
      }, {
        "name": "静态解析分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1603",
        "id": 395,
        "icon": null
      }]
    }],
    'analyze': [{
      "name": "流量分析(隧道内)",
      "level": 2,
      "path": "ci0302",
      "id": 41,
      "icon": "fund"
    }, {
      "name": "4G流量统计",
      "level": 2,
      "path": "ci1803",
      "id": 43,
      "icon": "line-chart"
    }],
    'manage': [{
      "name": "企业信息",
      "level": 2,
      "path": "ci1001",
      "id": 51,
      "icon": "contacts"
    }, {
      "name": "运维账号",
      "level": 2,
      "path": "ci0701",
      "id": 52,
      "icon": "solution"
    }, {
      "name": "账期清单",
      "level": 2,
      "path": "ci1901",
      "id": 54,
      "icon": "profile"
    }, {
      "name": "4G卡登记",
      "level": 2,
      "path": "ci1801",
      "id": 55,
      "icon": "schedule"
    }]
  },
  //技术支持
  supercxptechsupport: {
    'home': [{
      "name": "首页",
      "level": 2,
      "path": "bi0101",
      "id": 11,
      "icon": "home"
    }],
    'monitoring': [{
      "name": "设备列表",
      "level": 2,
      "path": "bi0301",
      "id": 21,
      "icon": "database"
    }, {
      "name": "链路信息",
      "level": 2,
      "path": "ci0201",
      "id": 22,
      "icon": "share-alt"
    }, {
      "name": "客户端信息",
      "level": 2,
      "id": 23,
      "path": "ci4301",
      "icon": "desktop"
    }, {
      "name": "告警信息",
      "level": 2,
      "id": 25,
      "path": "ci2501",
      "icon": "alert"
    }, {
      "name": "操作日志",
      "level": 2,
      "id": 26,
      "path": "ci2401",
      "icon": "file-text"
    }, {
      "name": "用户访问日志",
      "level": 2,
      "id": 27,
      "path": "ci2402",
      "icon": "code"
    }, {
      "name": "任务中心",
      "level": 2,
      "id": 28,
      "path": "ci0805",
      "icon": "file-sync"
    }],
    'configuration': [{
      "name": "构建网络",
      "level": 2,
      "path": "ci2001",
      "id": 31,
      "icon": "deployment-unit",
      "sub": [{
        "name": "常规链路",
        "level": 3,
        "parent_id": 31,
        "path": "bi1101",
        "id": 311,
        "icon": null
      }, {
        "name": "FullMesh链路",
        "level": 3,
        "parent_id": 31,
        "path": "bi1801",
        "id": 312,
        "icon": null
      }, {
        "name": "中心节点",
        "level": 3,
        "parent_id": 31,
        "path": "ci2101",
        "id": 313,
        "icon": null
      }, {
        "name": "边缘节点",
        "level": 3,
        "parent_id": 31,
        "path": "ci2201",
        "id": 314,
        "icon": null
      }, {
        "name": "设备配置",
        "level": 3,
        "parent_id": 31,
        "path": "ci2801",
        "id": 315,
        "icon": null
      }, {
        "name": "设备绑定",
        "level": 3,
        "parent_id": 31,
        "path": "ci3001",
        "id": 316,
        "icon": null
      }, {
        "name": "中心线路配置",
        "level": 3,
        "parent_id": 31,
        "path": "ci1401",
        "id": 317,
        "icon": null
      }, {
        "name": "上云申请",
        "level": 3,
        "parent_id": 31,
        "path": "bi2001",
        "id": 318,
        "icon": null
      }, {
        "name": "HA配置",
        "level": 3,
        "parent_id": 31,
        "path": "bi2501",
        "id": 319,
        "icon": null
      }, {
        "name": "出口方向",
        "level": 3,
        "parent_id": 31,
        "path": "bi2502",
        "id": 320,
        "icon": null
      }, {
        "name": "链路带宽",
        "level": 3,
        "parent_id": 31,
        "path": "bi2503",
        "id": 321,
        "icon": null
      }]
    }, {
      "name": "QoS配置",
      "level": 2,
      "id": 32,
      "path": "ci0500",
      "icon": "control",
      "sub": [{
        "name": "隧道QoS",
        "level": 3,
        "parent_id": 32,
        "path": "ci0601",
        "id": 321,
        "icon": null
      }, {
        "name": "互联网QoS",
        "level": 3,
        "parent_id": 32,
        "path": "ci3901",
        "id": 322,
        "icon": null
      }, {
        "name": "QoS2.0",
        "level": 3,
        "parent_id": 32,
        "path": "ci0602",
        "id": 327,
        "icon": null
      }, {
        "name": "单IP限速",
        "level": 3,
        "parent_id": 32,
        "path": "ci4001",
        "id": 324,
        "icon": null
      }, {
        "name": "IP限速",
        "level": 3,
        "parent_id": 32,
        "path": "ci3906",
        "id": 326,
        "icon": null
      }, {
        "name": "IP限速2.0",
        "level": 3,
        "parent_id": 32,
        "path": "ci3907",
        "id": 328,
        "icon": null
      }, {
        "name": "代理优化",
        "level": 3,
        "parent_id": 32,
        "path": "ci3908",
        "id": 329,
        "icon": null
      }]
    }, {
      "name": "安全防护",
      "level": 2,
      "path": "ci3800",
      "icon": "safety",
      "id": 33,
      "sub": [{
        "name": "ACL配置",
        "level": 3,
        "parent_id": 33,
        "path": "ci0501",
        "id": 331,
        "icon": null
      }, {
        "name": "Mac访问控制",
        "level": 3,
        "parent_id": 35,
        "path": "ci4101",
        "id": 332,
        "icon": null
      }, {
        "name": "基础防护",
        "level": 3,
        "parent_id": 35,
        "path": "ci4102",
        "id": 333,
        "icon": null
      }]
    }, {
      "name": "客户端配置",
      "level": 2,
      "path": "ci3700",
      "icon": "desktop",
      "id": 34,
      "sub": [{
        "name": "客户端授权",
        "level": 3,
        "parent_id": 34,
        "path": "ci3702",
        "id": 341,
        "icon": null
      }, {
        "name": "客户端账号",
        "level": 3,
        "parent_id": 34,
        "path": "ci0702",
        "id": 342,
        "icon": null
      }, {
        "name": "客户端链路",
        "level": 3,
        "parent_id": 34,
        "path": "ci0703",
        "id": 346,
        "icon": null
      }, {
        "name": "客户端网段",
        "level": 3,
        "parent_id": 34,
        "path": "ci3701",
        "id": 343,
        "icon": null
      }, {
        "name": "Mac认证",
        "level": 3,
        "parent_id": 34,
        "path": "ci3703",
        "id": 344,
        "icon": null
      }, {
        "name": "SaaS访问权限",
        "level": 3,
        "parent_id": 34,
        "path": "ci3704",
        "id": 345,
        "icon": null
      }]
    }, {
      "name": "告警配置",
      "level": 2,
      "path": "ci2600",
      "icon": "alert",
      "id": 35,
      "sub": [{
        "name": "告警接收",
        "level": 3,
        "parent_id": 35,
        "path": "mi2601",
        "id": 351,
        "icon": null
      }, {
        "name": "告警事件",
        "level": 3,
        "parent_id": 35,
        "path": "ci2602",
        "id": 352,
        "icon": null
      },
      // {
      //     "name": "健康标准",
      //     "level": 3,
      //     "parent_id": 35,
      //     "path": "ci2603",
      //     "id": 353,
      //     "icon": null
      // },
      {
        "name": "屏蔽策略",
        "level": 3,
        "parent_id": 35,
        "path": "ci2604",
        "id": 354,
        "icon": null
      }]
    }, {
      "name": "高级配置",
      "level": 2,
      "path": "ci3700",
      "icon": "setting",
      "id": 36,
      "sub": [{
        "name": "源地址引流",
        "level": 3,
        "parent_id": 36,
        "path": "ci3904",
        "id": 366,
        "icon": null
      }, {
        "name": "目标引流",
        "level": 3,
        "parent_id": 36,
        "path": "ci3903",
        "id": 361,
        "icon": null
      },
      // {
      //     "name": "专家路策略",
      //     "level": 3,
      //     "parent_id": 36,
      //     "path": "mi0602",
      //     "id": 367,
      //     "icon": null
      // },
      {
        "name": "多线路负载",
        "level": 3,
        "parent_id": 36,
        "path": "ci4105",
        "id": 362,
        "icon": null
      }, {
        "name": "多线路DNS代理",
        "level": 3,
        "parent_id": 36,
        "path": "ci4106",
        "id": 363,
        "icon": null
      }, {
        "name": "域名解析",
        "level": 3,
        "parent_id": 36,
        "path": "ci4104",
        "id": 364,
        "icon": null
      }, {
        "name": "Wi-Fi配置",
        "level": 3,
        "parent_id": 36,
        "path": "ci4103",
        "id": 365,
        "icon": null
      }]
    }, {
      "name": "模版配置",
      "level": 2,
      "path": "ci3300",
      "id": 37,
      "icon": "container",
      "sub": [{
        "name": "LAN模版",
        "level": 3,
        "parent_id": 37,
        "path": "ci3301",
        "id": 371,
        "icon": null
      }, {
        "name": "SSID模版",
        "level": 3,
        "parent_id": 37,
        "path": "ci3201",
        "id": 372,
        "icon": null
      }, {
        "name": "CPE模版",
        "level": 3,
        "parent_id": 37,
        "path": "ci3101",
        "id": 373,
        "icon": null
      }]
    }, {
      "name": "应用管理",
      "level": 2,
      "path": "ci3800",
      "icon": "appstore",
      "id": 38,
      "sub": [{
        "name": "自定义应用",
        "level": 3,
        "parent_id": 38,
        "path": "ci3801",
        "id": 381,
        "icon": null
      }, {
        "name": "自定义分组",
        "level": 3,
        "parent_id": 38,
        "path": "ci3803",
        "id": 382,
        "icon": null
      }, {
        "name": "系统应用",
        "level": 3,
        "parent_id": 38,
        "path": "bi1301",
        "id": 383,
        "icon": null
      }]
    }, {
      "name": "对象分组",
      "level": 2,
      "id": 39,
      "path": "ci1501",
      "icon": "folder-open",
      "sub": [{
        "name": "节点分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1502",
        "id": 391,
        "icon": null
      }, {
        "name": "域名分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1503",
        "id": 392,
        "icon": null
      }, {
        "name": "IP分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1601",
        "id": 393,
        "icon": null
      }, {
        "name": "用户分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1602",
        "id": 394,
        "icon": null
      }, {
        "name": "静态解析分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1603",
        "id": 395,
        "icon": null
      }]
    }, {
      "name": "预制路径标签",
      "level": 2,
      "id": 40,
      "path": "mi0604",
      "icon": "pull-request"
    }],
    'analyze': [{
      "name": "链路负载率",
      "level": 2,
      "path": "mi1401",
      "id": 41,
      "icon": "pull-request"
    }, {
      "name": "流量分析(隧道内)",
      "level": 2,
      "path": "ci0302",
      "id": 42,
      "icon": "fund"
    }, {
      "name": "压缩流量分析",
      "level": 2,
      "path": "mi1202",
      "id": 44,
      "icon": "funnel-plot"
    }],
    'manage': [{
      "name": "客户账号",
      "level": 2,
      "path": "bi1201",
      "id": 51,
      "icon": "solution"
    }, {
      "name": "客户合同",
      "level": 2,
      "path": "bi0201",
      "id": 52,
      "icon": "audit"
    }, {
      "name": "客户联系人",
      "level": 2,
      "path": "bi1202",
      "id": 53,
      "icon": "usergroup-add"
    }, {
      "name": "客户Logo设置",
      "level": 2,
      "path": "ci1201",
      "id": 54,
      "icon": "file-image"
    }, {
      "name": "登录背景图设置",
      "level": 2,
      "path": "bi1203",
      "id": 55,
      "icon": "file-image"
    }]
  },
  supercxptechadmin: {
    'home': [{
      "name": "首页",
      "level": 2,
      "path": "bi0101",
      "id": 11,
      "icon": "home"
    }],
    'monitoring': [{
      "name": "设备列表",
      "level": 2,
      "path": "bi0301",
      "id": 21,
      "icon": "database"
    }, {
      "name": "链路信息",
      "level": 2,
      "path": "ci0201",
      "id": 22,
      "icon": "share-alt"
    }, {
      "name": "客户端信息",
      "level": 2,
      "id": 23,
      "path": "ci4301",
      "icon": "desktop"
    }, {
      "name": "告警信息",
      "level": 2,
      "id": 25,
      "path": "ci2501",
      "icon": "alert"
    }, {
      "name": "操作日志",
      "level": 2,
      "id": 26,
      "path": "ci2401",
      "icon": "file-text"
    }, {
      "name": "用户访问日志",
      "level": 2,
      "id": 27,
      "path": "ci2402",
      "icon": "code"
    }, {
      "name": "任务中心",
      "level": 2,
      "id": 28,
      "path": "ci0805",
      "icon": "file-sync"
    }],
    'configuration': [{
      "name": "构建网络",
      "level": 2,
      "path": "ci2001",
      "id": 31,
      "icon": "deployment-unit",
      "sub": [{
        "name": "常规链路",
        "level": 3,
        "parent_id": 31,
        "path": "bi1101",
        "id": 311,
        "icon": null
      }, {
        "name": "FullMesh链路",
        "level": 3,
        "parent_id": 31,
        "path": "bi1801",
        "id": 312,
        "icon": null
      }, {
        "name": "中心节点",
        "level": 3,
        "parent_id": 31,
        "path": "ci2101",
        "id": 313,
        "icon": null
      }, {
        "name": "边缘节点",
        "level": 3,
        "parent_id": 31,
        "path": "ci2201",
        "id": 314,
        "icon": null
      }, {
        "name": "设备配置",
        "level": 3,
        "parent_id": 31,
        "path": "ci2801",
        "id": 315,
        "icon": null
      }, {
        "name": "设备绑定",
        "level": 3,
        "parent_id": 31,
        "path": "ci3001",
        "id": 316,
        "icon": null
      }, {
        "name": "中心线路配置",
        "level": 3,
        "parent_id": 31,
        "path": "ci1401",
        "id": 317,
        "icon": null
      }, {
        "name": "上云申请",
        "level": 3,
        "parent_id": 31,
        "path": "bi2001",
        "id": 318,
        "icon": null
      }, {
        "name": "HA配置",
        "level": 3,
        "parent_id": 31,
        "path": "bi2501",
        "id": 319,
        "icon": null
      }, {
        "name": "出口方向",
        "level": 3,
        "parent_id": 31,
        "path": "bi2502",
        "id": 320,
        "icon": null
      }, {
        "name": "链路带宽",
        "level": 3,
        "parent_id": 31,
        "path": "bi2503",
        "id": 321,
        "icon": null
      }]
    }, {
      "name": "QoS配置",
      "level": 2,
      "id": 32,
      "path": "ci0500",
      "icon": "control",
      "sub": [{
        "name": "隧道QoS",
        "level": 3,
        "parent_id": 32,
        "path": "ci0601",
        "id": 321,
        "icon": null
      }, {
        "name": "互联网QoS",
        "level": 3,
        "parent_id": 32,
        "path": "ci3901",
        "id": 322,
        "icon": null
      }, {
        "name": "QoS2.0",
        "level": 3,
        "parent_id": 32,
        "path": "ci0602",
        "id": 327,
        "icon": null
      }, {
        "name": "单IP限速",
        "level": 3,
        "parent_id": 32,
        "path": "ci4001",
        "id": 324,
        "icon": null
      }, {
        "name": "IP限速",
        "level": 3,
        "parent_id": 32,
        "path": "ci3906",
        "id": 326,
        "icon": null
      }, {
        "name": "IP限速2.0",
        "level": 3,
        "parent_id": 32,
        "path": "ci3907",
        "id": 328,
        "icon": null
      }, {
        "name": "代理优化",
        "level": 3,
        "parent_id": 32,
        "path": "ci3908",
        "id": 329,
        "icon": null
      }]
    }, {
      "name": "安全防护",
      "level": 2,
      "path": "ci3800",
      "icon": "safety",
      "id": 33,
      "sub": [{
        "name": "ACL配置",
        "level": 3,
        "parent_id": 33,
        "path": "ci0501",
        "id": 331,
        "icon": null
      }, {
        "name": "Mac访问控制",
        "level": 3,
        "parent_id": 35,
        "path": "ci4101",
        "id": 332,
        "icon": null
      }, {
        "name": "基础防护",
        "level": 3,
        "parent_id": 35,
        "path": "ci4102",
        "id": 333,
        "icon": null
      }]
    }, {
      "name": "客户端配置",
      "level": 2,
      "path": "ci3700",
      "icon": "desktop",
      "id": 34,
      "sub": [{
        "name": "客户端授权",
        "level": 3,
        "parent_id": 34,
        "path": "ci3702",
        "id": 341,
        "icon": null
      }, {
        "name": "客户端账号",
        "level": 3,
        "parent_id": 34,
        "path": "ci0702",
        "id": 342,
        "icon": null
      }, {
        "name": "客户端链路",
        "level": 3,
        "parent_id": 34,
        "path": "ci0703",
        "id": 346,
        "icon": null
      }, {
        "name": "客户端网段",
        "level": 3,
        "parent_id": 34,
        "path": "ci3701",
        "id": 343,
        "icon": null
      }, {
        "name": "Mac认证",
        "level": 3,
        "parent_id": 34,
        "path": "ci3703",
        "id": 344,
        "icon": null
      }, {
        "name": "SaaS访问权限",
        "level": 3,
        "parent_id": 34,
        "path": "ci3704",
        "id": 345,
        "icon": null
      }]
    }, {
      "name": "告警配置",
      "level": 2,
      "path": "ci2600",
      "icon": "alert",
      "id": 35,
      "sub": [{
        "name": "告警接收",
        "level": 3,
        "parent_id": 35,
        "path": "mi2601",
        "id": 351,
        "icon": null
      }, {
        "name": "告警事件",
        "level": 3,
        "parent_id": 35,
        "path": "ci2602",
        "id": 352,
        "icon": null
      },
      // {
      //     "name": "健康标准",
      //     "level": 3,
      //     "parent_id": 35,
      //     "path": "ci2603",
      //     "id": 353,
      //     "icon": null
      // },
      {
        "name": "屏蔽策略",
        "level": 3,
        "parent_id": 35,
        "path": "ci2604",
        "id": 354,
        "icon": null
      }]
    }, {
      "name": "高级配置",
      "level": 2,
      "path": "ci3700",
      "icon": "setting",
      "id": 36,
      "sub": [{
        "name": "源地址引流",
        "level": 3,
        "parent_id": 36,
        "path": "ci3904",
        "id": 366,
        "icon": null
      }, {
        "name": "目标引流",
        "level": 3,
        "parent_id": 36,
        "path": "ci3903",
        "id": 361,
        "icon": null
      },
      // {
      //     "name": "专家路策略",
      //     "level": 3,
      //     "parent_id": 36,
      //     "path": "mi0602",
      //     "id": 367,
      //     "icon": null
      // },
      {
        "name": "多线路负载",
        "level": 3,
        "parent_id": 36,
        "path": "ci4105",
        "id": 362,
        "icon": null
      }, {
        "name": "多线路DNS代理",
        "level": 3,
        "parent_id": 36,
        "path": "ci4106",
        "id": 363,
        "icon": null
      }, {
        "name": "域名解析",
        "level": 3,
        "parent_id": 36,
        "path": "ci4104",
        "id": 364,
        "icon": null
      }, {
        "name": "Wi-Fi配置",
        "level": 3,
        "parent_id": 36,
        "path": "ci4103",
        "id": 365,
        "icon": null
      }]
    }, {
      "name": "模版配置",
      "level": 2,
      "path": "ci3300",
      "id": 37,
      "icon": "container",
      "sub": [{
        "name": "LAN模版",
        "level": 3,
        "parent_id": 37,
        "path": "ci3301",
        "id": 371,
        "icon": null
      }, {
        "name": "SSID模版",
        "level": 3,
        "parent_id": 37,
        "path": "ci3201",
        "id": 372,
        "icon": null
      }, {
        "name": "CPE模版",
        "level": 3,
        "parent_id": 37,
        "path": "ci3101",
        "id": 373,
        "icon": null
      }]
    }, {
      "name": "应用管理",
      "level": 2,
      "path": "ci3800",
      "icon": "appstore",
      "id": 38,
      "sub": [{
        "name": "自定义应用",
        "level": 3,
        "parent_id": 38,
        "path": "ci3801",
        "id": 381,
        "icon": null
      }, {
        "name": "自定义分组",
        "level": 3,
        "parent_id": 38,
        "path": "ci3803",
        "id": 382,
        "icon": null
      }, {
        "name": "系统应用",
        "level": 3,
        "parent_id": 38,
        "path": "bi1301",
        "id": 383,
        "icon": null
      }]
    }, {
      "name": "对象分组",
      "level": 2,
      "id": 39,
      "path": "ci1501",
      "icon": "folder-open",
      "sub": [{
        "name": "节点分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1502",
        "id": 391,
        "icon": null
      }, {
        "name": "域名分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1503",
        "id": 392,
        "icon": null
      }, {
        "name": "IP分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1601",
        "id": 393,
        "icon": null
      }, {
        "name": "用户分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1602",
        "id": 394,
        "icon": null
      }, {
        "name": "静态解析分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1603",
        "id": 395,
        "icon": null
      }]
    }, {
      "name": "预制路径标签",
      "level": 2,
      "id": 40,
      "path": "mi0604",
      "icon": "pull-request"
    }],
    'analyze': [{
      "name": "链路负载率",
      "level": 2,
      "path": "mi1401",
      "id": 41,
      "icon": "pull-request"
    }, {
      "name": "流量分析(隧道内)",
      "level": 2,
      "path": "ci0302",
      "id": 42,
      "icon": "fund"
    }, {
      "name": "压缩流量分析",
      "level": 2,
      "path": "mi1202",
      "id": 44,
      "icon": "funnel-plot"
    }],
    'manage': [{
      "name": "客户账号",
      "level": 2,
      "path": "bi1201",
      "id": 51,
      "icon": "solution"
    }, {
      "name": "客户合同",
      "level": 2,
      "path": "bi0201",
      "id": 52,
      "icon": "audit"
    }, {
      "name": "客户联系人",
      "level": 2,
      "path": "bi1202",
      "id": 53,
      "icon": "usergroup-add"
    }, {
      "name": "客户Logo设置",
      "level": 2,
      "path": "ci1201",
      "id": 54,
      "icon": "file-image"
    }, {
      "name": "登录背景图设置",
      "level": 2,
      "path": "bi1203",
      "id": 55,
      "icon": "file-image"
    }]
  },
  //商务
  supercxpbusiness: {
    'home': [{
      "name": "首页",
      "level": 2,
      "path": "bi0101",
      "id": 11,
      "icon": "home"
    }],
    'monitoring': [{
      "name": "设备列表",
      "level": 2,
      "path": "bi0301",
      "id": 21,
      "icon": "database"
    }, {
      "name": "链路信息",
      "level": 2,
      "path": "ci0201",
      "id": 22,
      "icon": "share-alt"
    }, {
      "name": "客户端信息",
      "level": 2,
      "id": 23,
      "path": "ci4301",
      "icon": "desktop"
    }, {
      "name": "告警信息",
      "level": 2,
      "id": 25,
      "path": "ci2501",
      "icon": "alert"
    }, {
      "name": "操作日志",
      "level": 2,
      "id": 26,
      "path": "ci2401",
      "icon": "file-text"
    }, {
      "name": "用户访问日志",
      "level": 2,
      "id": 27,
      "path": "ci2402",
      "icon": "code"
    }, {
      "name": "POP点拓扑图",
      "level": 2,
      "path": "ci0802",
      "id": 28,
      "icon": "gateway"
    }],
    'configuration': [{
      "name": "计费设置",
      "level": 2,
      "path": "ci2001",
      "id": 31,
      "icon": "account-book",
      "sub": [{
        "name": "常规链路",
        "level": 3,
        "parent_id": 31,
        "path": "bi1101",
        "id": 311,
        "icon": null
      }, {
        "name": "FullMesh链路",
        "level": 3,
        "parent_id": 31,
        "path": "bi1801",
        "id": 312,
        "icon": null
      }]
    }, {
      "name": "访问权限",
      "level": 2,
      "path": "ci2000",
      "id": 32,
      "icon": "account-book",
      "sub": [{
        "name": "移动客户端",
        "level": 3,
        "parent_id": 32,
        "path": "ci3705",
        "id": 321,
        "icon": null
      }, {
        "name": "CPE设备",
        "level": 3,
        "parent_id": 32,
        "path": "ci3905",
        "id": 322,
        "icon": null
      }]
    }, {
      "name": "POP点配置",
      "level": 2,
      "path": "mi0601",
      "id": 33,
      "icon": "gateway"
    }],
    'analyze': [{
      "name": "链路负载率",
      "level": 2,
      "path": "mi1401",
      "id": 41,
      "icon": "pull-request"
    }, {
      "name": "流量分析(隧道内)",
      "level": 2,
      "path": "ci0302",
      "id": 42,
      "icon": "fund"
    }, {
      "name": "压缩流量分析",
      "level": 2,
      "path": "mi1202",
      "id": 44,
      "icon": "funnel-plot"
    }],
    'manage': [{
      "name": "账期管理",
      "level": 2,
      "path": "bi0701",
      "id": 51,
      "icon": "profile"
    }, {
      "name": "对账单",
      "level": 2,
      "path": "bi0202",
      "id": 52,
      "icon": "container"
    }, {
      "name": "合同管理",
      "level": 2,
      "path": "bi0201",
      "id": 53,
      "icon": "audit"
    }, {
      "name": "客户联系人",
      "level": 2,
      "path": "bi1202",
      "id": 54,
      "icon": "usergroup-add"
    }]
  },
  //商务主管
  supercxpbizadmin: {
    'home': [{
      "name": "首页",
      "level": 2,
      "path": "bi0101",
      "id": 11,
      "icon": "home"
    }],
    'monitoring': [{
      "name": "设备列表",
      "level": 2,
      "path": "bi0301",
      "id": 21,
      "icon": "database"
    }, {
      "name": "链路信息",
      "level": 2,
      "path": "ci0201",
      "id": 22,
      "icon": "share-alt"
    }, {
      "name": "客户端信息",
      "level": 2,
      "id": 23,
      "path": "ci4301",
      "icon": "desktop"
    }, {
      "name": "告警信息",
      "level": 2,
      "id": 25,
      "path": "ci2501",
      "icon": "alert"
    }, {
      "name": "操作日志",
      "level": 2,
      "id": 26,
      "path": "ci2401",
      "icon": "file-text"
    }, {
      "name": "用户访问日志",
      "level": 2,
      "id": 27,
      "path": "ci2402",
      "icon": "code"
    }, {
      "name": "POP点拓扑图",
      "level": 2,
      "path": "ci0802",
      "id": 28,
      "icon": "gateway"
    }],
    'configuration': [{
      "name": "计费设置",
      "level": 2,
      "path": "ci2001",
      "id": 31,
      "icon": "account-book",
      "sub": [{
        "name": "常规链路",
        "level": 3,
        "parent_id": 31,
        "path": "bi1101",
        "id": 311,
        "icon": null
      }, {
        "name": "FullMesh链路",
        "level": 3,
        "parent_id": 31,
        "path": "bi1801",
        "id": 312,
        "icon": null
      }]
    }, {
      "name": "访问权限",
      "level": 2,
      "path": "ci2000",
      "id": 32,
      "icon": "account-book",
      "sub": [{
        "name": "移动客户端",
        "level": 3,
        "parent_id": 32,
        "path": "ci3705",
        "id": 321,
        "icon": null
      }, {
        "name": "CPE设备",
        "level": 3,
        "parent_id": 32,
        "path": "ci3905",
        "id": 322,
        "icon": null
      }]
    }, {
      "name": "POP点配置",
      "level": 2,
      "path": "mi0601",
      "id": 33,
      "icon": "gateway"
    }],
    'analyze': [{
      "name": "链路负载率",
      "level": 2,
      "path": "mi1401",
      "id": 41,
      "icon": "pull-request"
    }, {
      "name": "流量分析(隧道内)",
      "level": 2,
      "path": "ci0302",
      "id": 42,
      "icon": "fund"
    }, {
      "name": "压缩流量分析",
      "level": 2,
      "path": "mi1202",
      "id": 44,
      "icon": "funnel-plot"
    }],
    'manage': [{
      "name": "账期管理",
      "level": 2,
      "path": "bi0701",
      "id": 51,
      "icon": "profile"
    }, {
      "name": "对账单",
      "level": 2,
      "path": "bi0202",
      "id": 52,
      "icon": "container"
    }, {
      "name": "合同管理",
      "level": 2,
      "path": "bi0201",
      "id": 53,
      "icon": "audit"
    }, {
      "name": "客户联系人",
      "level": 2,
      "path": "bi1202",
      "id": 54,
      "icon": "usergroup-add"
    }]
  },
  //运维
  supercxptechnology: {
    'home': [{
      "name": "首页",
      "level": 2,
      "path": "mi0001",
      "id": 11,
      "icon": "home"
    }],
    'monitoring': [{
      "name": "设备列表",
      "level": 2,
      "path": "mi0101",
      "id": 21,
      "icon": "database"
    }, {
      "name": "链路信息",
      "level": 2,
      "path": "mi0501",
      "id": 22,
      "icon": "share-alt"
    }, {
      "name": "客户端信息",
      "level": 2,
      "id": 23,
      "path": "ci4301",
      "icon": "desktop"
    }, {
      "name": "告警信息",
      "level": 2,
      "id": 25,
      "path": "ci2501",
      "icon": "alert"
    }, {
      "name": "任务信息",
      "level": 2,
      "id": 29,
      "path": "mc0101",
      "icon": "file-done"
    }, {
      "name": "操作日志",
      "level": 2,
      "id": 26,
      "path": "ci2401",
      "icon": "file-text"
    }, {
      "name": "用户访问日志",
      "level": 2,
      "id": 27,
      "path": "ci2402",
      "icon": "code"
    }, {
      "name": "任务中心",
      "level": 2,
      "id": 28,
      "path": "ci0805",
      "icon": "file-sync"
    }],
    'configuration': [{
      "name": "POP点配置",
      "level": 2,
      "path": "mi0601",
      "id": 31,
      "icon": "gateway"
    },
    // {
    //     "name": "专家路策略",
    //     "level": 2,
    //     "path": "mi0602",
    //     "id": 32,
    //     "icon": "branches",
    // },
    {
      "name": "Docker配置",
      "level": 2,
      "path": "mi1901",
      "id": 33,
      "icon": "database"
    }, {
      "name": "黑名单配置",
      "level": 2,
      "path": "mi0400",
      "id": 34,
      "icon": "lock",
      "sub": [{
        "name": "黑名单",
        "level": 3,
        "parent_id": 34,
        "path": "mi0401",
        "id": 341,
        "icon": null
      }, {
        "name": "关键词",
        "level": 3,
        "parent_id": 34,
        "path": "mi0402",
        "id": 342,
        "icon": null
      }, {
        "name": "域名关键词配置",
        "level": 3,
        "parent_id": 34,
        "path": "mi0403",
        "id": 343,
        "icon": null
      }]
    }, {
      "name": "资源库配置",
      "level": 2,
      "path": "mi2201",
      "id": 35,
      "icon": "folder"
    }, {
      "name": "资源分组",
      "level": 2,
      "path": "mi2202",
      "id": 36,
      "icon": "profile"
    }, {
      "name": "专线资源",
      "level": 2,
      "path": "ci0804",
      "id": 39,
      "icon": "share-alt"
    }, {
      "name": "机房信息",
      "level": 2,
      "path": "mi0301",
      "id": 37,
      "icon": "hdd"
    }, {
      "name": "告警配置",
      "level": 2,
      "path": "ci2600",
      "id": 38,
      "icon": "alert",
      "sub": [{
        "name": "告警接收",
        "level": 3,
        "parent_id": 38,
        "path": "mi2601",
        "id": 383,
        "icon": null
      }, {
        "name": "告警模版",
        "level": 3,
        "parent_id": 38,
        "path": "ci2605",
        "id": 384,
        "icon": null
      }]
    }, {
      "name": "预制路径标签",
      "level": 2,
      "id": 40,
      "path": "mi0604",
      "icon": "pull-request"
    }],
    'analyze': [{
      "name": "链路负载率",
      "level": 2,
      "path": "mi1401",
      "id": 41,
      "icon": "pull-request"
    }, {
      "name": "POP点负载率",
      "level": 2,
      "path": "mi2101",
      "id": 46,
      "icon": "environment"
    }, {
      "name": "流量分析(隧道内)",
      "level": 2,
      "path": "ci0302",
      "id": 42,
      "icon": "fund"
    }, {
      "name": "压缩流量分析",
      "level": 2,
      "path": "mi1202",
      "id": 44,
      "icon": "funnel-plot"
    }],
    'manage': [{
      "name": "库存管理",
      "level": 2,
      "path": "mi2000",
      "id": 51,
      "icon": "shop",
      "sub": [{
        "name": "出入库登记",
        "level": 3,
        "parent_id": 51,
        "path": "mi2001",
        "id": 511,
        "icon": null
      }, {
        "name": "库存信息",
        "level": 3,
        "parent_id": 51,
        "path": "mi0201",
        "id": 512,
        "icon": null
      }, {
        "name": "出库统计",
        "level": 3,
        "parent_id": 51,
        "path": "mi1601",
        "id": 513,
        "icon": null
      }]
    }, {
      "name": "版本管理",
      "level": 2,
      "path": "mi0800",
      "id": 52,
      "icon": "flag",
      "sub": [{
        "name": "版本汇总",
        "level": 3,
        "parent_id": 52,
        "path": "mi0802",
        "id": 521,
        "icon": null
      }, {
        "name": "版本更新",
        "level": 3,
        "parent_id": 52,
        "path": "mi0801",
        "id": 522,
        "icon": null
      }, {
        "name": "版本说明",
        "level": 3,
        "parent_id": 52,
        "path": "mi0803",
        "id": 523,
        "icon": null
      }, {
        "name": "客户端版本",
        "level": 3,
        "parent_id": 52,
        "path": "mi0804",
        "id": 524,
        "icon": null
      }, {
        "name": "客户端升级",
        "level": 3,
        "parent_id": 52,
        "path": "mi0805",
        "id": 525,
        "icon": null
      }]
    }, {
      "name": "运营商信息",
      "level": 2,
      "path": "mi1101",
      "id": 53,
      "icon": "profile"
    }, {
      "name": "关系人信息",
      "level": 2,
      "path": "mi1001",
      "id": 54,
      "icon": "usergroup-add"
    }, {
      "name": "历史数据",
      "level": 2,
      "path": "mi2000",
      "id": 55,
      "icon": "history",
      "sub": [{
        "name": "常规链路",
        "level": 3,
        "parent_id": 55,
        "path": "bi1101",
        "id": 551,
        "icon": null
      }, {
        "name": "FullMesh链路",
        "level": 3,
        "parent_id": 55,
        "path": "bi1801",
        "id": 552,
        "icon": null
      }]
    }]
  },
  //账号管理员
  supercxpadmin: {
    'home': [{
      "name": "账号管理",
      "level": 2,
      "parent_id": 34,
      "path": "pc0101",
      "id": 11,
      "icon": "team"
    }, {
      "name": "密码管理",
      "level": 2,
      "parent_id": 34,
      "path": "pc0201",
      "id": 12,
      "icon": "key"
    }, {
      "name": "控制器管理",
      "level": 2,
      "parent_id": 34,
      "path": "pc0601",
      "id": 13,
      "icon": "key"
    }, {
      "name": "操作日志",
      "level": 2,
      "parent_id": 34,
      "path": "pc0301",
      "id": 14,
      "icon": "file-text"
    }, {
      "sub": [{
        "name": "CPE型号",
        "level": 3,
        "parent_id": 15,
        "path": "pc0402",
        "id": 151,
        "icon": null
      }, {
        "name": "区域设置",
        "level": 3,
        "parent_id": 15,
        "path": "pc0403",
        "id": 152,
        "icon": null
      },
      //     {
      //     "name": "大区设置",
      //     "level": 3,
      //     "parent_id": 15,
      //     "path": "pc0404",
      //     "id": 153,
      //     "icon": null
      // },
      {
        "name": "授权管理",
        "level": 3,
        "parent_id": 15,
        "path": "pc0501",
        "id": 155,
        "icon": null
      }],
      "name": "参数设置",
      "level": 2,
      "parent_id": 34,
      "path": "pc0401",
      "id": 15,
      "icon": "tool"
    }]
  },
  //普通用户
  companystaff: {
    'home': [{
      "name": "首页",
      "level": 2,
      "path": "ci0801",
      "id": 11,
      "icon": "home"
    }],
    'monitoring': [{
      "name": "我的设备",
      "level": 2,
      "path": "ci0101",
      "id": 21,
      "icon": "database"
    }, {
      "name": "我的链路",
      "level": 2,
      "path": "ci0101",
      "id": 22,
      "icon": "share-alt",
      "sub": [{
        "name": "常规链路",
        "level": 3,
        "parent_id": 22,
        "path": "bi1803",
        "id": 221,
        "icon": null
      }, {
        "name": "FullMesh链路",
        "level": 3,
        "parent_id": 22,
        "path": "bi1801",
        "id": 222,
        "icon": null
      }, {
        "name": "出口方向",
        "level": 3,
        "parent_id": 22,
        "path": "bi2502",
        "id": 223,
        "icon": null
      }]
    }, {
      "name": "我的客户端",
      "level": 2,
      "id": 23,
      "path": "ci4301",
      "icon": "desktop"
    },
    // {
    //     "name": "地图模式",
    //     "level": 2,
    //     "id": 24,
    //     "path": "ci4201",
    //     "icon": "global"
    // },
    {
      "name": "告警信息",
      "level": 2,
      "id": 25,
      "path": "ci2501",
      "icon": "alert"
    }, {
      "name": "操作日志",
      "level": 2,
      "id": 26,
      "path": "ci2401",
      "icon": "file-text"
    }, {
      "name": "用户访问日志",
      "level": 2,
      "id": 27,
      "path": "ci2402",
      "icon": "code"
    }],
    'configuration': [{
      "name": "构建网络",
      "level": 2,
      "path": "ci2001",
      "id": 31,
      "icon": "deployment-unit",
      "sub": [{
        "name": "中心节点",
        "level": 3,
        "parent_id": 31,
        "path": "ci2101",
        "id": 311,
        "icon": null
      }, {
        "name": "边缘节点",
        "level": 3,
        "parent_id": 31,
        "path": "ci2201",
        "id": 312,
        "icon": null
      } // {
      //     "name": "设备配置",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "ci2801",
      //     "id": 313,
      //     "icon": null
      // }, {
      //     "name": "设备绑定",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "ci3001",
      //     "id": 314,
      //     "icon": null
      // },
      // {
      //     "name": "中心线路配置",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "ci1401",
      //     "id": 316,
      //     "icon": null
      // },
      // {
      //     "name": "HA配置",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "bi2501",
      //     "id": 315,
      //     "icon": null
      // },
      // {
      //     "name": "白名单",
      //     "level": 3,
      //     "parent_id": 31,
      //     "path": "ci0901",
      //     "id": 318,
      //     "icon": null
      // },
      ]
    },
    // {
    //     "name": "QoS配置",
    //     "level": 2,
    //     "id": 32,
    //     "path": "ci0500",
    //     "icon": "control",
    //     "sub": [
    //         {
    //             "name": "隧道QoS",
    //             "level": 3,
    //             "parent_id": 32,
    //             "path": "ci0601",
    //             "id": 321,
    //             "icon": null
    //         },
    //         {
    //             "name": "互联网QoS",
    //             "level": 3,
    //             "parent_id": 32,
    //             "path": "ci3901",
    //             "id": 322,
    //             "icon": null
    //         },
    //         {
    //             "name": "单IP限速",
    //             "level": 3,
    //             "parent_id": 32,
    //             "path": "ci4001",
    //             "id": 324,
    //             "icon": null
    //         },
    //         {
    //             "name": "IP限速",
    //             "level": 3,
    //             "parent_id": 32,
    //             "path": "ci3906",
    //             "id": 326,
    //             "icon": null
    //         },
    //     ]
    // },
    {
      "name": "安全防护",
      "level": 2,
      "path": "ci3800",
      "icon": "safety",
      "id": 33,
      "sub": [{
        "name": "ACL2.0",
        "level": 3,
        "parent_id": 33,
        "path": "ci0502",
        "id": 330,
        "icon": null
      }, {
        "name": "ACL配置",
        "level": 3,
        "parent_id": 33,
        "path": "ci0501",
        "id": 331,
        "icon": null
      } // {
      //     "name": "Mac访问控制",
      //     "level": 3,
      //     "parent_id": 35,
      //     "path": "ci4101",
      //     "id": 332,
      //     "icon": null
      // },
      // {
      //     "name": "基础防护",
      //     "level": 3,
      //     "parent_id": 35,
      //     "path": "ci4102",
      //     "id": 333,
      //     "icon": null
      // },
      ]
    }, {
      "name": "客户端配置",
      "level": 2,
      "path": "ci3700",
      "icon": "desktop",
      "id": 34,
      "sub": [{
        "name": "客户端账号",
        "level": 3,
        "parent_id": 34,
        "path": "ci0702",
        "id": 341,
        "icon": null
      }, {
        "name": "客户端网段",
        "level": 3,
        "parent_id": 34,
        "path": "ci3701",
        "id": 342,
        "icon": null
      }, {
        "name": "Mac认证",
        "level": 3,
        "parent_id": 34,
        "path": "ci3703",
        "id": 343,
        "icon": null
      }]
    }, {
      "name": "告警配置",
      "level": 2,
      "path": "ci2600",
      "icon": "alert",
      "id": 35,
      "sub": [{
        "name": "告警接收",
        "level": 3,
        "parent_id": 35,
        "path": "mi2601",
        "id": 351,
        "icon": null
      }, {
        "name": "告警事件",
        "level": 3,
        "parent_id": 35,
        "path": "ci2602",
        "id": 352,
        "icon": null
      } // {
      //     "name": "健康标准",
      //     "level": 3,
      //     "parent_id": 35,
      //     "path": "ci2603",
      //     "id": 353,
      //     "icon": null
      // },
      ]
    },
    // {
    //     "name": "高级配置",
    //     "level": 2,
    //     "path": "ci3700",
    //     "icon": "setting",
    //     "id": 36,
    //     "sub": [
    //         {
    //             "name": "源地址引流",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci3904",
    //             "id": 361,
    //             "icon": null
    //         },
    //         {
    //             "name": "多线路负载",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci4105",
    //             "id": 362,
    //             "icon": null
    //         },
    //         {
    //             "name": "多线路DNS代理",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci4106",
    //             "id": 363,
    //             "icon": null
    //         },
    //         {
    //             "name": "域名解析",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci4104",
    //             "id": 364,
    //             "icon": null
    //         },
    //         {
    //             "name": "Wi-Fi配置",
    //             "level": 3,
    //             "parent_id": 36,
    //             "path": "ci4103",
    //             "id": 365,
    //             "icon": null
    //         },
    //     ]
    // },
    // {
    //     "name": "模版配置",
    //     "level": 2,
    //     "path": "ci3300",
    //     "id": 37,
    //     "icon": "container",
    //     "sub": [
    //         {
    //             "name": "LAN模版",
    //             "level": 3,
    //             "parent_id": 37,
    //             "path": "ci3301",
    //             "id": 371,
    //             "icon": null
    //         },
    //         {
    //             "name": "SSID模版",
    //             "level": 3,
    //             "parent_id": 37,
    //             "path": "ci3201",
    //             "id": 372,
    //             "icon": null
    //         },
    //         {
    //             "name": "CPE模版",
    //             "level": 3,
    //             "parent_id": 37,
    //             "path": "ci3101",
    //             "id": 373,
    //             "icon": null
    //         },
    //     ]
    // },
    {
      "name": "应用管理",
      "level": 2,
      "path": "ci3800",
      "icon": "appstore",
      "id": 38,
      "sub": [{
        "name": "自定义应用",
        "level": 3,
        "parent_id": 38,
        "path": "ci3801",
        "id": 381,
        "icon": null
      }, {
        "name": "自定义分组",
        "level": 3,
        "parent_id": 38,
        "path": "ci3803",
        "id": 382,
        "icon": null
      } // {
      //     "name": "系统应用",
      //     "level": 3,
      //     "parent_id": 38,
      //     "path": "ci3802",
      //     "id": 383,
      //     "icon": null
      // },
      ]
    }, {
      "name": "对象分组",
      "level": 2,
      "id": 39,
      "path": "ci1501",
      "icon": "folder-open",
      "sub": [{
        "name": "节点分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1502",
        "id": 391,
        "icon": null
      }, {
        "name": "域名分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1503",
        "id": 392,
        "icon": null
      }, {
        "name": "IP分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1601",
        "id": 393,
        "icon": null
      }, {
        "name": "用户分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1602",
        "id": 394,
        "icon": null
      }, {
        "name": "静态解析分组",
        "level": 3,
        "parent_id": 39,
        "path": "ci1603",
        "id": 395,
        "icon": null
      }]
    }],
    'analyze': [{
      "name": "流量分析(隧道内)",
      "level": 2,
      "path": "ci0302",
      "id": 41,
      "icon": "fund"
    }, {
      "name": "4G流量统计",
      "level": 2,
      "path": "ci1803",
      "id": 43,
      "icon": "line-chart"
    }],
    'manage': [{
      "name": "企业信息",
      "level": 2,
      "path": "ci1001",
      "id": 51,
      "icon": "contacts"
    }, {
      "name": "账期清单",
      "level": 2,
      "path": "ci1901",
      "id": 54,
      "icon": "profile"
    }, {
      "name": "4G卡登记",
      "level": 2,
      "path": "ci1801",
      "id": 55,
      "icon": "schedule"
    }]
  },
  menuonlyshow: {
    'home': [{
      "name": "首页",
      "level": 2,
      "path": "ci0801",
      "id": 11,
      "icon": "home"
    }],
    'monitoring': [{
      "name": "我的设备",
      "level": 2,
      "path": "ci0101",
      "id": 21,
      "icon": "database"
    }, {
      "name": "我的链路",
      "level": 2,
      "path": "ci0101",
      "id": 22,
      "icon": "share-alt",
      "sub": [{
        "name": "常规链路",
        "level": 3,
        "parent_id": 22,
        "path": "bi1803",
        "id": 221,
        "icon": null
      }, {
        "name": "FullMesh链路",
        "level": 3,
        "parent_id": 22,
        "path": "bi1801",
        "id": 222,
        "icon": null
      }]
    }, {
      "name": "我的客户端",
      "level": 2,
      "id": 23,
      "path": "ci4301",
      "icon": "desktop"
    },
    // {
    //     "name": "地图模式",
    //     "level": 2,
    //     "id": 24,
    //     "path": "ci4201",
    //     "icon": "global"
    // },
    {
      "name": "告警信息",
      "level": 2,
      "id": 25,
      "path": "ci2501",
      "icon": "alert"
    }, {
      "name": "操作日志",
      "level": 2,
      "id": 26,
      "path": "ci2401",
      "icon": "file-text"
    }, {
      "name": "用户访问日志",
      "level": 2,
      "id": 27,
      "path": "ci2402",
      "icon": "code"
    }],
    'analyze': [{
      "name": "流量分析(隧道内)",
      "level": 2,
      "path": "ci0302",
      "id": 41,
      "icon": "fund"
    }, {
      "name": "4G流量统计",
      "level": 2,
      "path": "ci1803",
      "id": 43,
      "icon": "line-chart"
    }]
  }
};
export { menuInfo };